import type { IAffiliatesApproveRequest } from '@modules/affiliates-pending/types';
import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useI18n } from '@modules/i18n/composables';
import { useToastStore } from '@modules/toast/store';

import {
  AFFILIATES_REQUEST_HISTORY_CHANGE_STATUS_MUTATION_KEY,
  AFFILIATES_REQUEST_HISTORY_CHANGE_STATUS_URL,
  AFFILIATES_REQUEST_HISTORY_LIST_QUERY_KEY,
  AFFILIATES_REQUEST_HISTORY_PERMISSIONS,
  TRANSLATION_GROUP_AFFILIATES_REQUEST_HISTORY,
} from '../constants';

export default function useChangeAffiliatesStatusRequestHistoryMutation(): IContextMutationResult<
  void,
  Error,
  IAffiliatesApproveRequest
> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();
  const { getTranslation } = useI18n();

  return useContextMutation<void, Error, IAffiliatesApproveRequest>({
    mutationKey: [AFFILIATES_REQUEST_HISTORY_CHANGE_STATUS_MUTATION_KEY],
    mutationFn: ({ id, ...payload }) => fetchPost<void>(
      AFFILIATES_REQUEST_HISTORY_CHANGE_STATUS_URL,
      payload,
      {
        permission: AFFILIATES_REQUEST_HISTORY_PERMISSIONS.CHANGE_STATUS,
        urlParams: { id },
      },
    ),
    onSuccess({ queryClient }) {
      displayPresetToast('success', getTranslation(TRANSLATION_GROUP_AFFILIATES_REQUEST_HISTORY, 'TOAST_STATUS_CHANGED').value);
      void queryClient.invalidateQueries({ queryKey: [AFFILIATES_REQUEST_HISTORY_LIST_QUERY_KEY] });
    },
  });
}
